/*
 * MEDOEL – Ilustraciones botánicas de las notas olfativas.
 *
 * Cada nota (p. ej. «Rosa turca», «Canela», «Bergamota») se asocia a una familia de ingredientes
 * y cada familia tiene un dibujo de línea fina (SVG 64×64, trazo = currentColor).
 *
 * API (window.MedoelBotanica):
 *   kindOf(nota)             → clave de la familia ('rosa', 'citrico'…), o 'chispa' si no se reconoce.
 *   svg(clave, clase)        → cadena SVG del dibujo.
 *   halo(elemento, notas)    → pinta hasta 6 dibujos con su nombre alrededor de un elemento (se anima el trazo).
 *   garland(elemento, notas) → igual que halo, pero en fila (ficha de producto).
 *   decorate(raíz)           → añade un icono pequeño a cada etiqueta .lx-note que aún no lo tenga.
 *
 * Marcado:
 *   <div data-lxb-halo data-notes='["Rosa","Canela"]'></div>     (se pinta al cargar)
 *   <div data-lxb-garland data-notes='[…]'></div>
 * Las secciones pueden volver a llamar a halo() al cambiar de perfume.
 */
(function () {
  'use strict';

  /* ---------- Dibujos (viewBox 0 0 64 64). La clase "a" marca los detalles en oro. ---------- */
  var petal = function (cx, cy, len, w, angle) {
    // Pétalo en forma de gota que sale del centro (cx, cy) hacia arriba y se gira «angle» grados.
    return '<path transform="rotate(' + angle + ' ' + cx + ' ' + cy + ')" d="M' + cx + ' ' + cy +
      'c-' + w + '-' + len * 0.35 + '-' + w + '-' + len * 0.8 + ' 0-' + len +
      'c' + w + ' ' + len * 0.2 + ' ' + w + ' ' + len * 0.65 + ' 0 ' + len + 'z"/>';
  };
  var ring = function (n, fn) { var s = ''; for (var i = 0; i < n; i++) s += fn(i); return s; };
  var leaf = function (x, y, dx, dy) {
    // Hoja apuntada desde (x, y) hasta (x+dx, y+dy) con su nervio.
    var f = function (v) { return +v.toFixed(1); };
    var mx = dx / 2, my = dy / 2, nx = -dy * 0.32, ny = dx * 0.32;
    var start = 'M' + x + ' ' + y;
    return '<path d="' + start + 'q' + f(mx + nx) + ' ' + f(my + ny) + ' ' + dx + ' ' + dy +
      start + 'q' + f(mx - nx) + ' ' + f(my - ny) + ' ' + dx + ' ' + dy + '"/>' +
      '<path d="' + start + 'l' + f(dx * 0.8) + ' ' + f(dy * 0.8) + '"/>';
  };

  var ART = {
    rosa:
      '<path d="M21 17c0 11 5 18 11 18s11-7 11-18c-3 3-7 4-11 1-4 3-8 2-11-1z"/>' +
      '<path d="M25 15c1-5 4-8 7-9 3 1 6 4 7 9"/>' +
      '<path class="a" d="M32 26c-3-2-3-6 0-9 2 2 2 4 0 6"/>' +
      '<path d="M24 28c3 2 6 2 8 0 2 2 5 2 8 0"/>' +
      '<path d="M32 35v22"/>' + leaf(32, 45, -11, -7) + leaf(32, 51, 10, -6) +
      '<path d="M32 40l-3-2M32 49l3-1"/>',
    blancas:
      '<g>' + ring(5, function (i) { return petal(32, 24, 12, 5, i * 72); }) + '</g>' +
      '<circle class="a" cx="32" cy="24" r="2.2"/>' +
      '<path d="M32 26c0 9-3 18-9 30"/>' + leaf(28, 42, -11, -5) +
      '<g transform="translate(44 40) scale(.55)">' + ring(5, function (i) { return petal(0, 0, 11, 5, i * 72 + 36); }) + '</g>' +
      '<path d="M30 34c5 1 10 3 14 6"/>',
    flor:
      '<path d="M32 13c4 0 6 3 5 7 4-2 8 0 8 4s-4 6-7 5c2 4 0 8-4 8-2 0-3-1-2-2-1 1-2 2-4 2-4 0-6-4-4-8-3 1-7-1-7-5s4-6 8-4c-1-4 1-7 5-7z"/>' +
      '<path d="M32 19c-3 2-4 5-2 8M32 19c3 2 4 5 2 8M27 26c2 2 7 2 10 0"/>' +
      '<circle class="a" cx="32" cy="27" r="2"/>' +
      '<path d="M32 37v20"/>' + leaf(32, 47, -12, -5) + leaf(32, 52, 11, -4),
    lavanda:
      '<path d="M30 58c1-14 2-30 4-46"/>' +
      ring(6, function (i) {
        var y = 14 + i * 5.5, x = 33.6 - i * 0.55;
        return '<path d="M' + x + ' ' + y + 'c-4-1-6-3-6-6 3 0 6 2 6 6z"/><path d="M' + x + ' ' + y + 'c4-1 6-3 6-6-3 0-6 2-6 6z"/>';
      }) +
      '<path class="a" d="M34 12c0-3 1-5 2-6"/>' + leaf(30.5, 52, -9, -9),
    citrico:
      '<circle cx="29" cy="38" r="15"/><circle cx="29" cy="38" r="12"/>' +
      ring(8, function (i) {
        var a = (i * 45) * Math.PI / 180;
        return '<path d="M29 38L' + (29 + Math.cos(a) * 11).toFixed(1) + ' ' + (38 + Math.sin(a) * 11).toFixed(1) + '"/>';
      }) +
      '<circle class="a" cx="29" cy="38" r="1.6"/>' +
      '<path d="M40 24c2-4 4-7 7-9"/>' + leaf(43, 20, 13, -8),
    rojos:
      '<circle cx="24" cy="40" r="7"/><circle cx="37" cy="44" r="7"/><circle cx="30" cy="51" r="6"/>' +
      '<path class="a" d="M21 38a3 3 0 0 1 3-2M34 42a3 3 0 0 1 3-2"/>' +
      '<path d="M24 33c2-8 6-14 12-18M37 37c-1-8 0-15 -1-22M30 45c0-6 2-12 6-30"/>' + leaf(36, 15, 14, -4),
    fruta:
      '<path d="M32 23c-6-4-17-2-17 11 0 11 7 20 12 20 2 0 3-1 5-1s3 1 5 1c5 0 12-9 12-20 0-13-11-15-17-11z"/>' +
      '<path d="M32 23c0-5 1-8 3-10"/>' + leaf(35, 16, 12, -4) +
      '<path class="a" d="M22 32c1-3 3-5 5-5"/>',
    tropical:
      '<ellipse cx="32" cy="42" rx="10" ry="13"/>' +
      '<path d="M24 35l15 15M23 43l11 10M27 30l14 14M40 35L25 50M41 43L31 53M37 30L23 44"/>' +
      '<path class="a" d="M32 29c-1-7-4-11-9-14M32 29c0-8 0-12 1-17M32 29c1-7 4-11 9-14M32 29c-4-4-8-6-13-6M32 29c4-4 8-6 13-6"/>',
    vainilla:
      '<path d="M14 54C24 42 33 30 42 16"/><path d="M18 56C28 44 37 32 46 18"/><path d="M42 16c2-1 4 0 4 2"/>' +
      '<path d="M16 50c3-2 6-5 8-8M24 44c2-2 4-4 6-7"/>' +
      '<g transform="translate(46 36)">' + ring(5, function (i) { return petal(0, 0, 9, 4, i * 72); }) + '</g>' +
      '<circle class="a" cx="46" cy="36" r="1.8"/>',
    especias:
      '<path d="M10 44l28-15M12 49l28-15M10 44c-2 1-2 4 2 5M38 29c3-1 5 2 2 5"/>' +
      '<path d="M13 37l28-15M15 42l28-15M13 37c-2 1-2 4 2 5M41 22c3-1 5 2 2 5"/>' +
      '<g class="a" transform="translate(46 46)">' + ring(8, function (i) {
        return '<path transform="rotate(' + i * 45 + ')" d="M0 0c-2-3-2-7 0-10 2 3 2 7 0 10z"/>';
      }) + '<circle r="1.6"/></g>',
    hierbas:
      '<path d="M22 58C26 42 32 26 44 8"/>' +
      leaf(25, 47, -11, -4) + leaf(26, 45, 10, -9) + leaf(29, 37, -11, -6) + leaf(31, 34, 11, -8) +
      leaf(34, 27, -10, -7) + leaf(36, 24, 10, -8) + leaf(39, 17, -8, -7) +
      '<path class="a" d="M44 8c1-2 2-3 3-3"/>',
    madera:
      '<ellipse cx="30" cy="34" rx="18" ry="15"/>' +
      '<path d="M30 25c7 0 11 4 11 9s-5 9-11 9-11-4-11-9 5-9 11-9z"/><path d="M30 30c3 0 5 2 5 4s-2 4-5 4-5-2-5-4 2-4 5-4z"/>' +
      '<path class="a" d="M30 19l2 10"/>' +
      '<path d="M44 46c4 3 8 6 13 7M49 49c2-2 4-3 7-3"/>' + leaf(52, 51, 6, -9),
    resina:
      '<path d="M18 44c0-6 6-12 6-12s6 6 6 12a6 6 0 0 1-12 0z"/>' +
      '<path d="M32 50c0-4 4-8 4-8s4 4 4 8a4 4 0 0 1-8 0z"/>' +
      '<path class="a" d="M21 45a3 3 0 0 0 3 3"/>' +
      '<path d="M44 36c-5-5 5-8 0-13s5-8 0-13M50 34c-4-4 4-7 0-11"/>',
    almizcle:
      '<path d="M14 56C26 42 38 26 50 8"/>' +
      '<path d="M50 8c-9 2-18 9-24 20-3 6-5 12-6 18 6-6 12-9 18-13 7-5 11-13 12-25z"/>' +
      '<path d="M30 30l-6-3M34 24l-6-3M38 18l-6-3M35 33l6 0M40 26l6-1"/>' +
      '<path class="a" d="M20 47l-5 1"/>',
    cuero:
      '<path d="M20 13c4 2 8 2 12 0s8-2 12 0c-1 6 2 10 5 14-3 5-3 11 0 16-4 2-6 6-5 10-4-2-8-2-12 0s-8 2-12 0c1-4-1-8-5-10 3-5 3-11 0-16 3-4 6-8 5-14z"/>' +
      '<path class="a" stroke-dasharray="2 3" d="M23 18c3 1 6 1 9 0s6-1 9 0c0 5 2 8 4 11-2 4-2 8 0 12-3 2-5 5-4 8-3-1-6-1-9 0s-6 1-9 0c0-3-2-6-4-8 2-4 2-8 0-12 2-3 4-6 4-11z"/>',
    tabaco:
      '<path d="M32 58C12 46 12 20 32 6c20 14 20 40 0 52z"/>' +
      '<path d="M32 58V10"/>' +
      '<path d="M32 20l-8-5M32 28l-11-6M32 36l-12-6M32 44l-10-5M32 20l8-5M32 28l11-6M32 36l12-6M32 44l10-5"/>' +
      '<path class="a" d="M32 58v4"/>',
    cafe:
      '<ellipse transform="rotate(-30 24 34)" cx="24" cy="34" rx="9" ry="13"/>' +
      '<path transform="rotate(-30 24 34)" d="M24 21c-4 5 4 9 0 13s4 9 0 13"/>' +
      '<ellipse transform="rotate(25 42 38)" cx="42" cy="38" rx="8" ry="11"/>' +
      '<path class="a" transform="rotate(25 42 38)" d="M42 27c-3 4 3 8 0 11s3 8 0 11"/>',
    dulce:
      '<path d="M44 10L30 30"/>' +
      '<path d="M30 30c-4-3-11 0-14 5s-2 11 2 13 10-1 13-6 3-9-1-12z"/>' +
      '<path d="M18 38l12 8M20 33l12 8M24 30l9 6"/>' +
      '<path class="a" d="M20 50c0 3-1 5-2 7a2 2 0 0 0 4 0c0-2-1-4-2-7z"/>',
    acuatico:
      '<path d="M8 40c4-4 8-4 12 0s8 4 12 0 8-4 12 0 8 4 12 0"/>' +
      '<path d="M8 48c4-4 8-4 12 0s8 4 12 0 8-4 12 0 8 4 12 0"/>' +
      '<path d="M32 10c0 0 8 9 8 15a8 8 0 0 1-16 0c0-6 8-15 8-15z"/>' +
      '<path class="a" d="M28 25a4 4 0 0 0 4 4"/>',
    secos:
      '<path d="M22 50c-8-6-8-22 4-32 6 8 8 22-4 32z"/><path d="M22 50c0-10 2-20 4-32"/>' +
      '<path d="M40 52c-7-4-9-17 0-26 7 6 9 18 0 26z"/><path class="a" d="M40 52c-1-8 0-17 0-26"/>',
    licor:
      '<path d="M18 14h28c0 12-6 20-14 20s-14-8-14-20z"/>' +
      '<path d="M32 34v18M22 56h20"/>' +
      '<path class="a" d="M20 20c8 2 16 2 24 0"/>' +
      '<circle cx="28" cy="25" r="1"/><circle cx="35" cy="22" r="1.3"/><circle cx="37" cy="27" r="0.9"/>',
    chispa:
      '<path class="a" d="M32 12c1 10 4 13 14 14-10 1-13 4-14 14-1-10-4-13-14-14 10-1 13-4 14-14z"/>' +
      '<path d="M46 40c.5 5 2 6.5 7 7-5 .5-6.5 2-7 7-.5-5-2-6.5-7-7 5-.5 6.5-2 7-7z"/>'
  };

  /* ---------- Nota → familia (la primera regla que coincide gana; el orden importa) ---------- */
  var RULES = [
    ['licor', /\b(ron|co[ñn]ac|whisky|vodka|champ|amaretto|licor|cola)\b/],
    ['cafe', /caf[eé]|cacao|chocolate|capuchino/],
    ['vainilla', /vainilla|tonka/],
    ['secos', /almendra|avellana|pistacho|nuez(?! moscada)|nueces|casta[ñn]a|frutos secos|frutas secas/],
    ['especias', /canela|cardamomo|nuez moscada|pimienta|clavo|jengibre|azafr|comino|c[uú]rcuma|an[ií]s|especia/],
    ['citrico', /bergamota|lim[oó]n|\blima\b|naranja|mandarina|pomelo|yuzu|cidra|kumquat|c[ií]tric|tangerina|petit ?grain/],
    ['rosa', /\brosa|rosyfolia|pomarose/],
    ['blancas', /jazm|azahar|neroli|nardo|gardenia|ylang|frangipani|magnolia|azucena|lirio de los valles|flores blancas|madreselva/],
    ['lavanda', /lavanda/],
    ['rojos', /frambuesa|fresa|cereza|guinda|grosella|casis|bayas|zarzamora|ar[aá]ndano|frutos rojos|\bmoras?\b/],
    ['tropical', /pi[ñn]a|mango|coco|maracuy|tropical|guayaba|pitahaya|pl[aá]tano|lichi|sand[ií]a|mel[oó]n/],
    ['flor', /peon|violeta|iris|lirio|orqu|heliotropo|mimosa|fresia|geranio|flor|floral|osmanto|cal[eé]ndula|loto|nen[uú]far|siempreviva|mahonial/],
    ['fruta', /manzana|\bpera\b|melocot|albaricoque|ciruela|higo|uva|granada|d[aá]til|fruta|afrutad|frutal|ruibarbo|mirabel/],
    ['dulce', /caramelo|pralin|miel|az[uú]car|tofe|malvavisco|crema|dulce|merengue|helado|bizcocho|goloso|br[uû]l|knafeh|leche|lacton|mascarpone|chicle|regaliz|cera de|confitad|s'mores|tarta|gourmand/],
    ['tabaco', /tabaco/],
    ['cuero', /cuero|gamuza/],
    ['hierbas', /musgo|pachul/],
    ['madera', /madera|cedro|s[aá]ndalo|vetiver|guayaco|palisandro|amberwood|akigal|roble|abeto|cipr[eé]s|palo santo|cypriol|\boud\b|agar|abedul|amaderad|\barce\b/],
    ['almizcle', /almizcle|ambrox|cashmeran|[aá]mbar gris|aldeh|atalcad|polvo|ambrofix|ambreta|jab[oó]n|cachemira/],
    ['resina', /[aá]mbar|benju|l[aá]dano|incienso|ol[ií]bano|mirra|b[aá]lsamo|opop|elem[ií]|resin|cade|tol[uú]/],
    ['acuatico', /marin|acu[aá]tic|\bsal\b|algas|oz[oó]n|agua|roc[ií]o|cristal|pepino|hielo/],
    ['hierbas', /salvia|romero|menta|albahaca|artemisa|abr[oó]tano|verde|\bt[eé]\b|enebro|esclarea|g[aá]lbano|arom[aá]tic|herbal|hojas|cilantro|semillas|davana|tagetes/]
  ];
  var cache = {};
  function kindOf(note) {
    var n = String(note || '').toLowerCase();
    if (cache[n]) return cache[n];
    for (var i = 0; i < RULES.length; i++) if (RULES[i][1].test(n)) return (cache[n] = RULES[i][0]);
    return (cache[n] = 'chispa');
  }

  function svg(kind, cls) {
    return '<svg class="' + (cls || 'lxb-svg') + '" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
      (ART[kind] || ART.chispa) + '</svg>';
  }

  // Escoge hasta «max» familias distintas alternando salida, corazón y fondo para que estén las tres.
  function pick(notes, max) {
    var tiers = Array.isArray(notes[0]) ? notes : [notes];
    var seen = {}, out = [], i = 0, added = true;
    while (out.length < max && added) {
      added = false;
      for (var t = 0; t < tiers.length && out.length < max; t++) {
        var list = tiers[t] || [];
        for (var k = i; k < list.length; k++) {
          var kind = kindOf(list[k]);
          if (kind === 'chispa' || seen[kind]) continue;
          seen[kind] = 1; out.push({ kind: kind, note: list[k] }); added = true;
          break;
        }
      }
      i++;
      if (i > 12) break;
    }
    return out;
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function paint(el, notes) {
    if (!el) return;
    var items = pick(notes || [], 6);
    el.classList.remove('is-drawn');
    el.innerHTML = items.map(function (it, i) {
      return '<figure class="lxb-item lxb-item--' + i + '" style="--i:' + i + '">' + svg(it.kind) +
        '<figcaption>' + String(it.note).replace(/[<>&]/g, '') + '</figcaption></figure>';
    }).join('');
    // pathLength=1 permite animar el trazo de cualquier forma con la misma dasharray.
    el.querySelectorAll('path, circle, ellipse').forEach(function (p) { p.setAttribute('pathLength', '1'); });
    if (reduce) { el.classList.add('is-drawn'); return; }
    void el.offsetWidth; // reinicia la animación
    requestAnimationFrame(function () { el.classList.add('is-drawn'); });
  }

  function decorate(root) {
    (root || document).querySelectorAll('.lx-note:not([data-lxb])').forEach(function (n) {
      n.setAttribute('data-lxb', '');
      n.insertAdjacentHTML('afterbegin', svg(kindOf(n.textContent), 'lxb-icon'));
    });
  }

  function readNotes(el) { try { return JSON.parse(el.getAttribute('data-notes') || '[]'); } catch (e) { return []; } }

  // Pinta los dibujos marcados en la página. Con data-lxb-onview espera a que el elemento sea visible
  // para que se vea cómo se dibuja el trazo.
  function init() {
    var els = document.querySelectorAll('[data-lxb-halo][data-notes], [data-lxb-garland][data-notes]');
    var io = !reduce && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        if (!en.target.childElementCount) paint(en.target, readNotes(en.target));
      });
    }, { rootMargin: '0px 0px -15% 0px' }) : null;
    els.forEach(function (el) {
      if (el.childElementCount) return;
      if (io && el.hasAttribute('data-lxb-onview')) io.observe(el);
      else paint(el, readNotes(el));
    });
    decorate(document);
  }

  window.MedoelBotanica = {
    kindOf: kindOf,
    svg: svg,
    halo: paint,
    garland: paint,
    decorate: decorate,
    kinds: Object.keys(ART)
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
